import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { FeatureFlagService, FeatureFlags } from "../shared/services/feature-flag.service";
import { AllBonListComponent } from "../modules/shared/bon/all-bon-list/all-bon-list.component";

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsGuard {

  constructor(
    private readonly featureFlagService : FeatureFlagService,
  ) {
  }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    // Vérifier d'abord si un feature flag spécifique est requis dans les données de la route
    const requiredFeatureFlag = route.data?.requiredFeatureFlag;
    if (requiredFeatureFlag) {
      switch (requiredFeatureFlag) {
        case 'ComptabiliteAmeliorations':
          return this.featureFlagService.isComptabiliteAmeliorationsEnabled();
        case 'Preview':
          return this.featureFlagService.isPreviewEnabled();
        default:
          return false;
      }
    }

    // Fallback pour les composants spécifiques (ancienne logique)
    switch (route.routeConfig.component) {
      case AllBonListComponent :
        return this.featureFlagService.isPreviewEnabled();
    }
   return false;
  }

}
